import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import range from 'lodash/range';
import s from '../../../../../redux/selectors';
import { wrap, withT } from '../../../../../lib/wrappers';

import InlineInput from '../InlineInput';
import InlineSelect from '../InlineSelect';
import BlankLink from '../../../../common/BlankLink';

const percentPvOptions = range(0.1, 1.1, 0.1).map(value => ({
  value, display: `${Math.round(value * 100)}%`,
})).reverse();

const PurchaseGreenElectricity = ({
  t,
  widgetSource,
  annualElectricityConsumption,
  resultTakeactionPurchaseGreenElectricityKwhCO2yr,
}) => (
  <div className="action-details">
    <div className="action-details__form">
      <span
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{
          __html: t('My household uses {{annualElectricityConsumption}} kilowatt hours of electricity per year, which produces {{resultTakeactionPurchaseGreenElectricityKwhCO2yr}} metric tons of CO<sub>2</sub>eq per year. I will meet', { annualElectricityConsumption, resultTakeactionPurchaseGreenElectricityKwhCO2yr }),
        }}
      />
      <InlineSelect
        apiKey="input_takeaction_install_PV_panels_percent"
        options={percentPvOptions}
      />
      {t('of my electricity from installing photovoltaic (PV) panels. It costs ')}
      <InlineInput
        currency
        apiKey="input_takeaction_install_PV_panels_w_cost"
        maxLength={4}
      />
      {t('per Watt.')}
    </div>
    <div className="action-details__links">
      {widgetSource !== 'ontario' &&
        <a
          href="http://www.coolcalifornia.org/funding-wizard#search/home+electricity//false/none/false/1/12"
          target="_blank"
          rel="noopener noreferrer"
        >{t('Find rebates and incentives for this action')}</a>
      }
      {widgetSource === 'ontario' &&
        <div>
          <p>
            {t('As a homeowner with a solar system, if you participate in the net metering program offered by your utility, you can save money by generating power with renewable energy.')}
          </p>
          <p>
            {t('To learn more, visit')}
            &nbsp;
            <BlankLink href={`https://${t('www.ontario.ca/page/save-your-energy-bill-net-metering')}`} text={t('www.ontario.ca/page/save-your-energy-bill-net-metering')} />.
          </p>
        </div>
      }
    </div>
    <div className="action-details__assumptions">
      <div className="action-details__assumptions__header">{t('Assumptions')}</div>
      <ul>
        <li>
          {t('cost of electricity')}
          <InlineInput
            apiKey="input_takeaction_assumption_kwhprice"
            maxLength={3}
          />
          {t('cents per kWh')}
        </li>
        <li>
          {widgetSource !== 'ontario' &&
            <span>
              <span>{t('We assume 1654 kWh per kilowatt annual generation capacity (average for California). Actual generation capacity will vary by location, panel orientation, tree shading and other factors. Checkout')}</span>
              &nbsp;
              <a
                href="https://www.solar-estimate.org/"
                target="_blank"
                rel="noopener noreferrer"
              >{t('Solar-Estimate.org')}</a>
              &nbsp;
              {t('for a more detailed estimate.')}
            </span>
          }
          {widgetSource === 'ontario' &&
            <span>{t('We assume 1654 kWh per kilowatt annual generation capacity. Actual generation capacity will vary by location, panel orientation, tree shading and other factors.')}</span>
          }
        </li>
      </ul>
    </div>
  </div>
);

PurchaseGreenElectricity.propTypes = {
  // wrapped
  t: PropTypes.func.isRequired,
  // connected props
  widgetSource: PropTypes.string.isRequired,
  annualElectricityConsumption: PropTypes.string.isRequired,
  resultTakeactionPurchaseGreenElectricityKwhCO2yr: PropTypes.string.isRequired,
};

const mapStateToProps = (state, ownProps) => [
  'annualElectricityConsumption',
  'widgetSource',
].reduce((props, selector) => ({
  ...props,
  [selector]: s[selector](state, ownProps),
}), {
  resultTakeactionPurchaseGreenElectricityKwhCO2yr: s.results('result_takeaction_purchase_green_electricity_kwhCO2yr', true)(state, ownProps),
});
const mapDispatchToProps = () => ({});

export default wrap(
  withT('installPvPanels'),
  connect(mapStateToProps, mapDispatchToProps)(PurchaseGreenElectricity),
);
